import Bowser from 'bowser';
import { sendAnalytics } from 'utils/analyticsUtils';
import { analyticsConstants } from 'constants/AnalyticsConst';

export const sendAuthorizationAnalyticsEvent = (result, error = '', event, sessionId) => {
    const authFailed = result !== analyticsConstants.result.success;

    const errorParts = error?.split('---');
    const reason = (errorParts?.length > 0 && errorParts[1]) || null;

    authFailed && sendAnalytics('sessionAccessUnauthorized', {
        sessionId,
        accountId: event['account-id'],
        sessionStatus: analyticsConstants.sessionStatus.atSession,
        result,
        resultReason: reason,
    });
};

/**
 * Checks if current browser is supported for virtual sessions
 */
export const isSupportedBrowser = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const baseSupportedVersions = {
        ie: '>=11',
        edge: '>=79',
        chrome: '>=72',
        firefox: '>=65',
        safari: '>=11',
        androidBrowser: '>=4.4'
    };
    const isValidBrowser = browser.satisfies({
        // declare browsers per OS
        windows: {
            ie: baseSupportedVersions.ie,
            edge: baseSupportedVersions.edge,
            chrome: baseSupportedVersions.chrome,
            firefox: baseSupportedVersions.firefox
        },
        macos: {
            chrome: baseSupportedVersions.chrome,
            firefox: baseSupportedVersions.firefox
        },

        // per platform (mobile, desktop or tablet)
        mobile: {
            safari: baseSupportedVersions.safari,
            'android browser': baseSupportedVersions.androidBrowser,
            chrome: baseSupportedVersions.chrome,
            firefox: baseSupportedVersions.firefox
        },
        ie: baseSupportedVersions.ie,
        edge: baseSupportedVersions.edge,
        chrome: baseSupportedVersions.chrome,
        firefox: baseSupportedVersions.firefox
    });
    return isValidBrowser;
};

export const checkVirtualCheckinTicket = (ticketsSelectionData) => {
    let ticketWithVirtualCheckinExists = false;
    ticketsSelectionData?.tickets?.forEach((ticket) => {
        if (ticket?.virtualCheckin) {
            ticketWithVirtualCheckinExists = true;
        }
    });
    return ticketWithVirtualCheckinExists;
};

